import React from 'react';
import styled from 'styled-components';
import { useStoreActions, useStoreState } from '../store';

export const Video = React.memo(() => {
  const videoRef = React.useRef<HTMLVideoElement | null>(null);
  const actions = useStoreActions(actions => actions);
  const muted = useStoreState((state) => state.config.muted);

  /**
   * Store video DOM element reference,
   * and initialize the video engine.
   */
  React.useEffect(() => {
    if (!videoRef.current) return;
    actions.player.setVideoElement(videoRef.current);
  }, [actions]);

  return (
    <VideoElement
      id="bod-video-player"
      autoPlay
      muted={muted}
      ref={videoRef}
      style={{ width: '100%', height: '100%' }}
      playsInline={true}
      controls={false}
      disablePictureInPicture={true}
    />
  );
});

const VideoElement = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;
